import { Inject } from "inversify-props"
import type { CashbackServiceAdapter } from "./adapter/CashbackServiceAdapter"
import { CampanhaCashback } from "@/models/CampanhaCashback"
import { AcaoDeCashback } from "@/models/AcaoDeCashback"
import { MetaDeAcaoDeCashback } from "@/models/MetaDeAcaoDeCashback"

export class SaveCashbackUseCase {
	@Inject('CashbackServiceAdapter')
	private cashBackServiceAdapter!: CashbackServiceAdapter

	criar = async (campanhaCashback: CampanhaCashback): Promise<CampanhaCashback> =>
		await this.cashBackServiceAdapter.criarCampanha(campanhaCashback)

	atualizar = async (campanhaCashback: CampanhaCashback): Promise<CampanhaCashback> =>
		await this.cashBackServiceAdapter.atualizarCampanha(campanhaCashback)

	criarAcaoDeCashback = async (acaoDeCashback: AcaoDeCashback): Promise<AcaoDeCashback> =>
		await this.cashBackServiceAdapter.criarAcaoDeCashback(acaoDeCashback)

	atualizarAcaoDeCashback = async (acaoDeCashback: AcaoDeCashback): Promise<AcaoDeCashback> =>
		await this.cashBackServiceAdapter.atualizarAcaoDeCashback(acaoDeCashback)

	excluirAcaoDeCashback = async (id: string): Promise<void> =>
		await this.cashBackServiceAdapter.excluirAcaoDeCashback(id)

	definirMetaDaAcaoDeCashback = async (acaoId: string, valorMeta: number): Promise<MetaDeAcaoDeCashback> =>
		await this.cashBackServiceAdapter.definirMetaDaAcaoDeCashback(acaoId, valorMeta)

	removerMetaDaAcaoDeCashback = async (acaoId: string): Promise<void> =>
		await this.cashBackServiceAdapter.removerMetaDaAcaoDeCashback(acaoId)
}